// extracted by mini-css-extract-plugin
export default {"supportBanner":"support_supportBanner__uOd4r"};